// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Dqoyx","buttons":"styles_buttons__3ZKQD"};